import LinkButton, {
  LinkButtonProps,
} from '@/decodo/components/atoms/LinkButton';
import { Text } from '@/decodo/components/atoms/Text';

export type OpenPositionsListItemProps = {
  title: string;
  location: string;
  type: string;
  button: LinkButtonProps;
};

export function OpenPositionsListItem({
  title,
  location,
  type,
  button,
}: OpenPositionsListItemProps) {
  return (
    <div className='flex flex-col justify-between gap-y-5 py-5 md:flex-row md:items-center lg:py-6'>
      <div className='flex flex-col items-start gap-y-3'>
        <LinkButton
          variant='text'
          slim
          color='secondary'
          href={button.href}
          textWrap
          data-tracker-component='text'
        >
          <Text variant='subtitle-l-d' classNames={{ wrapper: 'font-serif' }}>
            {title}
          </Text>
        </LinkButton>
        <Text variant='body-l' color='gray-dark-500'>
          {location} / {type}
        </Text>
      </div>
      <LinkButton
        variant='outlined'
        href={button.href}
        data-tracker-component='button-details'
        classNames={{ root: 'md:w-auto mt-6 sm:mt-0 w-full' }}
      >
        Details
      </LinkButton>
    </div>
  );
}
